import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

import "./step-section.css";
import "../hero-section.css";

const STEP__DATA = [
  {
    title: "Setup your wallet",
    desc: "1.Create your account and add a wallet",
    icon: "ri-wallet-line",
  },

  {
    title: "choose plans",
    desc: "2.Access to our review team standards",
    icon: "ri-layout-masonry-line",
  },

  {
    title: "Add your NFTs",
    desc: "3.Create your NFT and list it for sale ",
    icon: "ri-image-line",
  },

  {
    title: "List them for sale",
    desc: "4.Sell your item and get rewarded",
    icon: "ri-list-check",
  },
];

const StepSection = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="12" className="mb-4">
            <h3 className="step__title">Create and sell your NFTs</h3>
          </Col>

          {STEP__DATA.map((item, index) => (
            <Col lg="3" md="4" sm="6" key={index} className="mb-4">
              <div className="single__step__item">
                <span>
                  <i class={item.icon}></i>
                </span>
                <div className="step__item__content">
                  <h5>
                    <Link to="/wallet">{item.title}</Link>
                  </h5>
                  <p className="mb-0">{item.desc}</p>
                </div>
              </div>
            </Col>
            
          )
          
          )}
        </Row>
        
      </Container>
    </section>
  );
};

export default StepSection;
